import http from '@/http'

export type ResolvedParticipant = {
  id: number
  name: string
  email?: string
  status?: number
  // eslint-disable-next-line camelcase
  status_check?: number
  tags: { id: number, name: string }[]
}

export type ResolveResponse = {
  ok: boolean
  message?: string
  participant?: ResolvedParticipant
}

/**
 * Identifica o participante pelo código do QR SEM registrar check-in.
 * Usado pelos modos "Coleta de Lead" e "Brinde" da estação.
 */
export async function resolveCode (confirmationCode: string): Promise<ResolveResponse> {
  const response = await http.post('/admin/check-in/resolve', {
    confirmation_code: confirmationCode
  }, {
    validateStatus: () => true
  })

  if (response.status === 200 && response.data && response.data.participant) {
    return { ok: true, participant: response.data.participant }
  }

  return {
    ok: false,
    message: (response.data && response.data.message) || 'Não foi possível identificar o QR code.'
  }
}
